// Function to save data (add or update)
export const saveStorageItem = (key: string, value: any): void => {
    try {
        if (typeof value === 'string') {
            localStorage.setItem(key, value); // store as plain string
        } else {
            localStorage.setItem(key, JSON.stringify(value)); // store as JSON for number, boolean, object, array
        }
    } catch (e) {
        console.error('Error saving data', e);
    }
};

// Function to retrieve data
export const getStorageItem = (key: string): any | null => {
    try {
        const value = localStorage.getItem(key);
        if (!value) return null;

        // Check if it looks like JSON (starts with '{' or '[')
        if (value.startsWith('{') || value.startsWith('[')) {
            return JSON.parse(value);
        }
        return value; // return as plain string
    } catch (e) {
        console.error('Error retrieving data', e);
        return null;
    }
};


// Function to remove data
export const removeStorageItem = (key: string): void => {
    try {
        localStorage.removeItem(key);
        console.log('Data removed successfully');
    } catch (e) {
        console.error('Error removing data', e);
    }
};

// Function to update data (retrieve existing, modify, and save)
export const updateStorageItem = (key: string, newValue: any): void => {
    try {
        const existingData = getStorageItem(key);
        if (existingData !== null) {
            const updatedData = { ...existingData, ...newValue }; // Merge existing and new values
            saveStorageItem(key, updatedData);
            console.log('Data updated successfully');
        } else {
            console.log('No existing data found, saving as new.');
            saveStorageItem(key, newValue);
        }
    } catch (e) {
        console.error('Error updating data', e);
    }
};
